export default "__VITE_ASSET__DR0ISn7R__"